import {
  StyledContainer,
  StyledIconContainer,
  StyledLabel,
} from './styles/navigationItemStyles';
import { TNavigationItem } from './types';

export const NavigationItem = ({
  children,
  label,
  variant = 'circle',
  disabled = false,
  ...otherProps
}: TNavigationItem) => {
  return (
    <StyledContainer variant={variant} disabled={disabled} {...otherProps}>
      <StyledIconContainer
        variant={variant}
        className="navigation-icon-container"
        disabled={disabled}
      >
        {children}
      </StyledIconContainer>
      {label ? (
        <StyledLabel
          className="navigation-label"
          variant="caption"
          itemVariant={variant}
          disabled={disabled}
        >
          {label}
        </StyledLabel>
      ) : null}
    </StyledContainer>
  );
};
